import { Title } from '@gerdau/hefesto';
import React, { useEffect } from 'react';
import { EHelpFileEndpoint } from '../../../services/HelpMenu';
import { Container } from './styles';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { useDispatch, useSelector } from 'react-redux';
import DownloadHelpButton from './DownloadHelpButton';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { IHelpItem } from '../../../store/ducks/help-center/types';
import { ApplicationState } from '../../../store';

const HelpManuals: React.FC = () => {
  const dispatch = useDispatch();

  const { screenName } = getTaggingInformationScreen('help-manuals');

  const journeyViews = useSelector(
    (state: ApplicationState) => state.user.journeyViews || []
  );
  const fabricationView = useSelector(
    (state: ApplicationState) => state.user.roles.fabricationViewCustomers || []
  );

  const isNewJourney = journeyViews.length > 0;
  const isCorteDobra = fabricationView.length > 0;

  const items: IHelpItem[] = [
    {
      title: 'Como realizar o Login?',
      endpoint: EHelpFileEndpoint.HELP_LOGIN,
      taggingItemDescription: 'login'
    },
    {
      title: 'Como eu posso utilizar o painel de gestão?',
      endpoint: EHelpFileEndpoint.DASHBOARD,
      taggingItemDescription: 'manuaisDeAjuda_painelDeGestao_download'
    },
    {
      title: 'Como eu posso gerenciar meus usuários e notificações?',
      endpoint: EHelpFileEndpoint.ACCESS_MANAGEMENT,
      taggingItemDescription: 'manuaisDeAjuda_usuarioENotificacao_download'
    },
    {
      title: 'Como eu posso gerenciar meus pedidos?',
      endpoint: EHelpFileEndpoint.ORDERS,
      taggingItemDescription: 'manuaisDeAjuda_meusPedidos_download'
    },
    {
      title: 'Como eu posso gerenciar minhas finanças?',
      endpoint: EHelpFileEndpoint.INVOICES,
      taggingItemDescription: 'manuaisDeAjuda_minhasFinancas_download'
    },
    {
      title: 'Como solicitar renovação do meu Limite de Crédito?',
      endpoint: EHelpFileEndpoint.CREDIT_RENEW,
      taggingItemDescription: 'renovacao-credito'
    },
    {
      title: 'Como acessar a área de Ajuda?',
      endpoint: EHelpFileEndpoint.HELP_AREA,
      taggingItemDescription: 'ajuda'
    },
    {
      title: 'Como acompanhar meus pedidos de aços planos?',
      endpoint: EHelpFileEndpoint.PLAIN_ORDERS,
      taggingItemDescription: 'pedidos-planos'
    }
  ];

  if (isNewJourney) {
    items.push(
      {
        title: 'Como comprar?',
        endpoint: EHelpFileEndpoint.PURCHASE,
        taggingItemDescription: 'comprar-gmais'
      },
      {
        title: 'Como comprar por Vitrine?',
        endpoint: EHelpFileEndpoint.PURCHASE_CATALOG,
        taggingItemDescription: 'vitrine'
      },
      {
        title: 'Como comprar por Histórico?',
        endpoint: EHelpFileEndpoint.PURCHASE_HISTORIC,
        taggingItemDescription: 'historico'
      },
      {
        title: 'Como comprar por planilha?',
        endpoint: EHelpFileEndpoint.PURCHASE_SHEET,
        taggingItemDescription: 'planilha'
      },
      {
        title: 'Como comprar Selecionando os itens?',
        endpoint: EHelpFileEndpoint.PURCHASE_SELECTING,
        taggingItemDescription: 'selecionando-itens'
      }
    );
  }

  if (isCorteDobra) {
    items.push(
      {
        title: 'Como fazer seu Pedido Corte e Dobra?',
        endpoint: EHelpFileEndpoint.CORTE_DOBRA_BUY,
        taggingItemDescription: 'commprar-cd'
      },
      {
        title: 'Como revisar seu Pedido Corte e Dobra?',
        endpoint: EHelpFileEndpoint.CORTE_DOBRA_REVIEW,
        taggingItemDescription: 'revisar-cd'
      },
      {
        title: 'Como criar uma Maquete Corte e Dobra?',
        endpoint: EHelpFileEndpoint.CORTE_DOBRA_MODEL,
        taggingItemDescription: 'maquete-cd'
      }
    );
  }

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName,
        page: window.location.pathname,
        event: 'page_view'
      })
    );
  }, []);

  return (
    <Container>
      <header data-testid="manuals-header">
        <Title level={2}>Manuais de ajuda?</Title>
        <p>
          Nesta página, disponibilizamos alguns tutorais com as principais
          dúvidas que você pode ter sobre a Gerdau mais.
        </p>
      </header>

      {items.map((item) => (
        <DownloadHelpButton item={item} key={item.title} />
      ))}
    </Container>
  );
};

export default HelpManuals;
